const dateOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
}

export const subtitleCreator = (firstName, lastName, publishDate) => `${firstName} ${lastName} - ${publishDate.toLocaleDateString('da-DK', dateOptions)}`
